import { getSbahnPlugin } from '@sie-private/telemetry-js';
import {
  isUsingEvidon, isUsingOneTrust, EvidonClient, OneTrustClient,
} from '@sie/web-common-react-components';
import { unifiedDefaultSchema } from '@rnps-ppr/telemetry-client-events';
import getBrowserString from '../getBrowserString';
import getCookie from '../getCookie';
import getUserSignInStatusOracle from './getUserSignInStatusOracle';
import getLineFromHost from '../getLineFromHost';
import TOOLBAR from '../../constants/toolbar';

const config = {
  appName: 'jetstream',
  buildVersion: '0.0.0',
  charset: 'utf-8',
  deviceId: '',
  deviceType: '',
  eventSchemas: [unifiedDefaultSchema],
  logLevel: 'off',
  overrides: {
    criteria: {
      line: 'e1-np|q1-np|sp-int|qa2|euqa',
    },
    overrideConfig: {
      logLevel: 'debug',
    },
  },
  platform: 'web',
  plugins: [getSbahnPlugin()],
  signedIn: '',
};

const getTelemetryJsPlatformPrivacyLevel = (async () => {
  let privacyPreference = 'minimal';

  if (!isUsingEvidon() && !isUsingOneTrust()) {
    const euCookiePreference = getCookie('eucookiepreference');
    if (!euCookiePreference || euCookiePreference === 'accept') {
      privacyPreference = 'all';
    }
  } else {
    const GdprClient = isUsingEvidon() ? EvidonClient : OneTrustClient;
    await new GdprClient().getPrivacyPreference().then((privacyPolicy) => {
      privacyPreference = privacyPolicy;
    });
    return privacyPreference;
  }
  return privacyPreference;
});

export default async function ({ DEVICES = {}, webToolbarType } = {}) {
  // match location with overrides
  const linePattern = new RegExp(config.overrides.criteria.line);
  const isDevEnv = window?.location.hostname.match(linePattern)?.length > 0;
  const telemetryJsConfig = isDevEnv ? Object.assign({}, config, config.overrides.overrideConfig)
    : config;

  telemetryJsConfig.buildVersion = process.env.JET_VERSION;
  telemetryJsConfig.deviceId = getBrowserString();
  telemetryJsConfig.platformPrivacyWs1 = await getTelemetryJsPlatformPrivacyLevel();
  telemetryJsConfig.deviceType = DEVICES.WEB;
  telemetryJsConfig.npEnv = getLineFromHost(window?.location?.hostname, { default: 'np' });

  const {
    name: oracleName,
  } = TOOLBAR.ORACLE;

  if (webToolbarType === oracleName) {
    return new Promise((resolve) => {
      getUserSignInStatusOracle(webToolbarType)
        .then((isSignedIn) => {
          telemetryJsConfig.signedIn = isSignedIn;

          resolve(telemetryJsConfig);
        });
    });
  }

  if (window && window.sbWeb && window.sbWeb.isUserSignedIn) {
    return new Promise((resolve) => {
      window.sbWeb.isUserSignedIn((status) => {
        telemetryJsConfig.signedIn = status;

        resolve(telemetryJsConfig);
      });
    });
  }

  return Promise.resolve(telemetryJsConfig);
}
